<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar @toggle-right-panel="handleToggleRightPanel" />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <right-panel v-if="showSettings" v-model="rightPanelShow">
        <settings />
      </right-panel>
      <!-- <div :class="{'fixed-footer':fixedHeader}">
        <footerbar />
      </div> -->
    </div>
    <!-- 预览选中效果弹窗 -->
    <el-dialog
      title="登录"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="30%"
    >
      <enterdialog ref="enterdialogview" @updataer="updataer" />
    </el-dialog>
  </div>
</template>

<script>
import RightPanel from '@/components/RightPanel'
import { AppMain, Navbar, Settings, Sidebar, TagsView /* Footerbar*/ } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
import { connectWebsocket } from '../utils/webSocket'
import enterdialog from '../views/enterpriseAstaff/components/enterdialog.vue'
export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    // Footerbar,
    RightPanel,
    Settings,
    Sidebar,
    TagsView,
    enterdialog
  },
  mixins: [ResizeMixin],
  data() {
    return {
      rightPanelShow: false,
      priwdialogVisible: false
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  created() {
    this.$store.dispatch('user/getInfo')
  },
  mounted() {
    console.log('mounted')
    const that = this
    connectWebsocket(
      // 测试地址
      process.env.VUE_APP_BACKUPSOCKET_API_URL,
      // 传递给后台的数据
      // 'openexe',
      { type: 'web_init', token: localStorage.getItem('Larke-Admin-Token') },
      // 成功拿到后台返回的数据的回调函数
      data => {
        console.log('成功的回调函数, 接收到的data数据: ', JSON.parse(data))
        if (JSON.parse(data).type === 'alert') {
          // eslint-disable-next-line eqeqeq
          if (JSON.parse(data).code == 1031) {
            console.log('1031')
            const res = JSON.parse(data)
            const notification = that.$notify({
              title: '消息',
              message: that.$createElement(
                'div',
                {
                  style: {
                    whiteSpace: 'normal', // 允许正常换行
                    wordBreak: 'break-all' // 长字符串也能断开
                  }
                },
                `点击 ${res.data.corp_user_name} / ${res.data.employee_no} (${res.data.corp_name}) 重新登录`
              ),
              duration: 300000,
              type: 'warning'
            })
            // 给整个通知框绑定点击事件
            // eslint-disable-next-line eqeqeq
            if (JSON.parse(data).code == 1031) {
              notification.$el.addEventListener('click', () => {
                console.log('通知被点击了，code=1031')
                // 👉 在这里写你需要的逻辑，比如跳转、调用接口等
                that.priwdialogVisible = true
                this.$nextTick(() => { // 请求成功之后，在这里执行
                  this.$refs.enterdialogview.send(JSON.parse(data))
                })
              })
            }
          } else {
            that.$notify.info({
              title: '消息',
              message: `${JSON.parse(data).data.msg}`,
              duration: 300000
            })
          }
        }
      },
      // websocket连接失败的回调函数
      err => {
        console.log('失败的回调函数', err)
      }
    )
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    handleToggleRightPanel() {
      this.rightPanelShow = !this.rightPanelShow
    },
    updataer() {
      this.priwdialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .fixed-footer {
      position: fixed;
      bottom: 0;
      right: 0;
      z-index: 9;
      width: calc(100% - 210px);
      -webkit-transition: width 0.28s;
      transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }
  .hideSidebar .fixed-footer {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
  .mobile .fixed-footer {
    width: 100%;
  }
</style>
